import type { ReactNode } from 'react'
import type { TopicStatus } from '@/api/topics/types'

const statusStyles: Record<TopicStatus, string> = {
  Open: 'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-100',
  Approved: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-100',
  Ignored: 'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-100',
}

const statusLabels: Record<TopicStatus, string> = {
  Open: 'Offen',
  Approved: 'Freigegeben',
  Ignored: 'Ignoriert',
}

export function StatusBadge({ status }: { readonly status: TopicStatus }): ReactNode {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${statusStyles[status]}`}
    >
      {statusLabels[status]}
    </span>
  )
}

export function Badge({ children }: { readonly children: ReactNode }): ReactNode {
  return (
    <span className="inline-flex items-center rounded bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-600 dark:bg-slate-700 dark:text-slate-200">
      {children}
    </span>
  )
}
